import { observable } from 'mobx';
import _ from 'lodash';

class ValidationStore {
  @observable accessor errorFields = [];
  @observable accessor responseError;

  constructor() {
    this.handleResponseError = this.handleResponseError.bind(this);
    this.setErrorMessageAndFields = this.setErrorMessageAndFields.bind(this);
    this.clearResponseErrors = this.clearResponseErrors.bind(this);
  }

  handleResponseError(error) {
    if (error.response.status === 500) {
      this.responseError = 'Er is iets verkeerd gegaan, probeer het later nog eens!';
    }

    if (error.response.status === 422) {
      this.responseError = 'Er is een fout met een van de volgde velden:';
      this.errorFields = _.values(JSON.parse(error.request.response));
    }
  }

  setErrorMessageAndFields(errorFields, response) {
    this.errorFields = errorFields;
    this.responseError = response;
  }

  clearResponseErrors() {
    this.errorFields = [];
    this.responseError = '';
  }
}

const ValidationData = new ValidationStore();

export default ValidationData;
